export default {
	dashboard: {
		documents: {
			title: 'New Documents',
			updatedSinceLastLogin:
				'These documents have been updated since your last {lastLogin}.',
		},
		buildings: {
			myObjects: 'My Buildings',
		},
	},
}
